<a [attr.title]="tooltip" [routerLink]="routerLink"><ng-content></ng-content></a>
